import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { CompanyGroupResponse } from '../models';


export class CompanyGroupState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public CompanyGroup: CompanyGroupResponse;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.CompanyGroup = null;
  }
}
